import { RootState } from '../store';

export const selectJobTimeOptions = (state: RootState) => state.jobTime.jobTimeOptions;

export const selectJobTimeOptionsRequestStatus = (state: RootState) => state.jobTime.jobTimeOptionsRequestStatus;
